import { z } from 'zod';

/**
 * Reference from backend implementation
 * https://bitbucket.org/atlassian/ml-studio/src/c141a1023fbf98c6b4de8627ca5999b460ab8f74/modules/src/ai_modeling/quickfind_user_doc_ranking/src/quickfind_user_doc_ranking/main.py#lines-577
 */
export enum RecommendedEventType {
	CLICKED = 'clicked',
	COMMENTED = 'commented',
	CREATED = 'created',
	EDITED = 'edited',
	INTERACTED = 'interacted',
	MENTIONED = 'mentioned',
	REACTED = 'reacted',
	READ = 'read',
	SHARED = 'shared',
	VIEWED = 'viewed',
}

export enum RecommendedType {
	COLLABORATOR = 'collaborator',
	NO_COLLABORATOR = 'no_collaborator',
}

const RecommendedReasonSchema: z.ZodObject<
	{
		type: z.ZodNativeEnum<typeof RecommendedType>;
		timestamp: z.ZodString;
		text: z.ZodString;
		feature: z.ZodOptional<z.ZodString>;
	},
	'strip'
> = z.object({
	type: z.nativeEnum(RecommendedType),
	timestamp: z.string().datetime(),
	text: z.string(),
	feature: z.string().optional(),
});

export type RecommendedReason = z.infer<typeof RecommendedReasonSchema>;

export const parseRecommendedReason = (
	reason: string | undefined,
	logException: (error: Error) => Promise<void>,
): RecommendedReason | null => {
	try {
		const result = RecommendedReasonSchema.safeParse(JSON.parse(reason || '{}'));
		if (result.success) {
			return result.data;
		}
		logException(result.error);
		return null;
	} catch (error) {
		logException(error as Error);
		return null;
	}
};
